import React from 'react';
import {withSystem, withMeta, Plugins, Atom} from '@packages/systems/wfdl';
import {
  CommerceCheckoutFormConstraint,
  SHARED_FORM_CONSTRAINTS_DESCENDANTS,
  SHARED_CHECKOUT_PAGE_SECTIONS_CONSTRAINTS,
} from '@packages/systems/core/constants/SharedConstraintRules';
import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import withAttribute from './withAttribute';
import {
  DATA_ATTR_NODE_TYPE,
  NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_METHODS_WRAPPER,
  SHIPPING_METHODS_STATES,
} from '@packages/systems/commerce/constants';
import {
  TEnum,
  TListOfElement,
  TRecord,
  TText,
  TTypeConstructor,
} from '@packages/systems/wfdl-ast';

import {typeName, qualify} from '@packages/systems/wfdl-Qualified';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {
  EvaluatedNodeData,
  getChildren,
  getInPojo,
  getString,
} from '@packages/utilities/data-utils';

const ShippingMethodsWrapper = Atom.createRender(
  ({attributes, classes, context, data, generateAttributes, renderChild}) => {
    const shippingMethodState =
      getString(getInPojo(data, ['temp', 'state'])) ??
      SHIPPING_METHODS_STATES.DEFAULT;
    const newContext = context.set('shippingMethodState', shippingMethodState);

    return (
      <form {...generateAttributes(attributes, classes)}>
        {getChildren(data).map((child: EvaluatedNodeData) =>
          renderChild(child, newContext)
        )}
      </form>
    );
  }
);

const config = createIntegratedAtom({
  displayName: 'Shipping Method',
  showSettingsInDescendants: true,
  showEmpty: true,
  constraints: {
    ancestors: [
      // @ts-expect-error - TS2322 - Type 'RelationshipConstraint | { readonly is: readonly ["CommerceCheckoutFormContainer", "CommercePaypalCheckoutFormContainer"]; readonly name: "Checkout Form"; readonly rule: "ExactlyOne"; }' is not assignable to type 'RelationshipConstraint'.
      ...SHARED_CHECKOUT_PAGE_SECTIONS_CONSTRAINTS,
      // @ts-expect-error - TS2322 - Type '{ readonly is: readonly ["CommerceCheckoutFormContainer", "CommercePaypalCheckoutFormContainer"]; readonly name: "Checkout Form"; readonly rule: "ExactlyOne"; }' is not assignable to type 'RelationshipConstraint'.
      CommerceCheckoutFormConstraint,
    ],
    descendants: [
      ...SHARED_CHECKOUT_PAGE_SECTIONS_CONSTRAINTS,
      ...SHARED_FORM_CONSTRAINTS_DESCENDANTS,
      {is: 'CommerceCheckoutShippingMethodsList', rule: 'ExactlyOne'},
      {is: 'CommerceCheckoutShippingMethodsEmptyState', rule: 'ExactlyOne'},
    ],
  },
  style: {
    base: {
      main: {
        noPseudo: {
          marginBottom: px(20),
        },
      },
    },
  },
  render: withAttribute(
    DATA_ATTR_NODE_TYPE,
    NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_METHODS_WRAPPER
  )(ShippingMethodsWrapper),
  fields: {
    tag: withSystem({defaultValue: 'form', private: true}, TText),
    source: withMeta(
      {
        source: 'Shipping Methods',
      },
      TTypeConstructor(
        qualify(Plugins.name('Commerce'), typeName('LockedDynSource'))
      )
    ),
    temp: TRecord({
      state: withSystem(
        {
          label: 'State',
          defaultValue: SHIPPING_METHODS_STATES.DEFAULT,
        },
        TEnum({
          [SHIPPING_METHODS_STATES.DEFAULT]: 'Default',
          [SHIPPING_METHODS_STATES.EMPTY]: 'Empty',
        })
      ),
    }),
    children: TListOfElement,
  },
});

export default config;
